import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const COOKIE_KEY = "km_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-fade-in">
      <div className="mx-auto max-w-3xl p-4">
        <div className="relative flex flex-col gap-4 rounded-2xl border border-border/50 bg-background/95 backdrop-blur-lg p-5 shadow-lg sm:flex-row sm:items-center sm:gap-6">
          <button
            onClick={decline}
            className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors sm:hidden"
            aria-label="Sulje"
          >
            <X className="h-4 w-4" />
          </button>
          <div className="flex-1 pr-6 sm:pr-0">
            <p className="text-sm text-foreground font-medium mb-1">
              Käytämme evästeitä 🍪
            </p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Käytämme välttämättömiä evästeitä kirjautumisen ja istunnon hallintaan.{" "}
              <a href="/tietosuoja" className="text-primary hover:underline underline-offset-2">
                Lue lisää tietosuojaselosteesta
              </a>
              .
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={decline}
              className="rounded-xl text-xs h-9 px-4"
            >
              Vain välttämättömät
            </Button>
            <Button
              size="sm"
              onClick={accept}
              className="rounded-xl text-xs h-9 px-4"
            >
              Hyväksy
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
